import { useGetMasterCoursesQuery } from "../../store/api/masterCourseApi";

export const useCoursesHook = () => {
  const { data: masterCourses, isLoading, error, refetch } = useGetMasterCoursesQuery();

  // Deduplicate by id as a safety measure
  const uniqueMasterCourses = (masterCourses || []).filter(
    (course, index, self) => index === self.findIndex((c) => c.id === course.id)
  );

  // Filter by difficulty based on level count or other criteria
  const filterByDifficulty = (difficulty: string) => {
    if (!uniqueMasterCourses) return [];
    return uniqueMasterCourses;
  };

  return {
    masterCourses: uniqueMasterCourses,
    isLoading,
    error,
    refetch,
    filterByDifficulty
  };
};
